export default __webpack_public_path__ + "static/media/tesla-now-2.43082c4a.png";